import React, { Component } from 'react'
import CodeMirror from 'codemirror'
import { connect } from 'react-redux'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/clike/clike'
import 'codemirror/mode/css/css'
import 'codemirror/mode/python/python'
import 'codemirror/mode/htmlembedded/htmlembedded'

import Actions from '@actions'
import { Loader } from '@components/UI'

class Code extends Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  componentDidMount() {
    if (this.props.file.id) this.load()
    else this.init(this.props.file.data, this.props.file.metadata)
  }

  load = () =>
    this.setState({ loading: true }, () => {
      const stop = () => this.setState({ loading: false })

      this.props.loadFile(
        (file) => {
          this.init(file.data, file.metadata)
          stop()
        },
        stop,
        this.props.file.id
      )
    })

  init = (data, metadata) => {
    this.editor = CodeMirror(this._editor, {
      mode: metadata.mode,
      lineWrapping: true,
      coverGutterNextToScrollbar: true,
      lineNumbers: true,
      readOnly: 'nocursor',
      tabSize: 2,
      ...(!this.props.light ? { theme: 'one-dark' } : {})
    })

    this.editor.setValue(data)
  }

  render() {
    const { className, light } = this.props

    return (
      <div
        className={`gp-code code-block ${className ? className : ''} ${
          light ? 'light' : ''
        }`}
      >
        <div ref={(elem) => (this._editor = elem)} className='editor' />
        {this.state.loading && <Loader full icon />}
      </div>
    )
  }
}

const mapActionsToProps = {
  loadFile: Actions.loadFile
}

export default connect(() => ({}), mapActionsToProps)(Code)
